import { InstallationBranchMoving } from "@/model/data/InstallationBranchMoving";
import { InstallationServiceModeSwitching } from "@/model/data/serviceMode/InstallationServiceModeSwitching";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/device/service_mode_history";

export class GetInstallationServiceModeHistoryCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: any;

    constructor(installationName: string) {
        super();
        this.params = { installationName: installationName };
    }

    public async execute(): Promise<GetInstallationServiceModeHistoryResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetInstallationServiceModeHistoryResData(res);
    }
}

export class GetInstallationServiceModeHistoryResData extends ApiGenericResponse {
    installationServiceModeHistory: InstallationServiceModeSwitching[];

    constructor(response: AxiosResponse) {
        super(response);
        this.installationServiceModeHistory = [];

        if (
            response.data &&
            response.data.Payload &&
            Array.isArray(response.data.Payload.InstallationServiceModeHistory) &&
            response.data.Payload.InstallationServiceModeHistory.length
        )
            this.parse(response.data.Payload.InstallationServiceModeHistory);
    }

    public parse(installationServiceModeSwitchingList: any) {
        installationServiceModeSwitchingList.forEach((installationServiceModeSwitching) => {
            var switching: InstallationServiceModeSwitching = new InstallationServiceModeSwitching();
            switching.parse(installationServiceModeSwitching);
            if (switching) this.installationServiceModeHistory.push(switching);
        });
    }
}
